export default {
    categories: [
        {
            label: 'shopping',
            name: 'Shopping'
          },
          {
            label: 'dine-drink',
            name: 'Dine & Drink'
          },
          {
            label: 'arts-culture',
            name: 'Arts & Culture'
          },
          {
            label: 'services',
            name: 'Services'
          },
          {
            label: 'parking',
            name: 'Parking'
          },
          {
            label: 'outdoors',
            name: 'Outdoors'
          }
    ]
}